"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.StayAlignedRelaxedPose = void 0;
var StayAlignedRelaxedPose;
(function (StayAlignedRelaxedPose) {
    StayAlignedRelaxedPose[StayAlignedRelaxedPose["STANDING"] = 0] = "STANDING";
    StayAlignedRelaxedPose[StayAlignedRelaxedPose["SITTING"] = 1] = "SITTING";
    StayAlignedRelaxedPose[StayAlignedRelaxedPose["FLAT"] = 2] = "FLAT";
})(StayAlignedRelaxedPose = exports.StayAlignedRelaxedPose || (exports.StayAlignedRelaxedPose = {}));
